import { Size } from './types';

export const DEFAULT_PROMPT = 'Perfect ass';

export const DEFAULT_SIZE: Size = { width: '512', height: '640' };
export const TALL_PORTRAIT_SIZE: Size = { width: '512', height: '768' };

export const PRIMARY_COLOR = '#d707a4'; //"#F787FF"; //"#30AFF3";
export const SECONDARY_COLOR = '#00E0E0';
export const PRIMARY_COLOR_DIMMED = 'rgba(215, 7, 164, 0.5)';
//export const PRIMARY_COLOR = '#B22222';

export const DARKER_PRIMARY_COLOR = '#d707a3c3';
//d707a4 in rbga = 215, 7, 164

export const GREEN_COLOR = '#00FF00';

export const PRIMARY_TEXT_COLOR = '#F0F0F0';
export const HOVER_COLOR = PRIMARY_TEXT_COLOR;
export const ICON_COLOR = PRIMARY_TEXT_COLOR;

export const SECONDARY_TEXT_COLOR = '#a8a8a8';
export const BORDER_COLOR = SECONDARY_TEXT_COLOR;

export const LIGHTER_GREY_COLOR = '#a3a3a3';

export const EVEN_LIGHTER_GREY_COLOR = '#e3e3e3';

export const LIGHT_GREY_COLOR = '#303134';
export const LIGHTER_GREY_FOR_HOVER_EFFECT = '#1f1a2b';

export const LIGHT_GREY_FOR_TAG = '#36313d6e';

export const DARK_GREY_COLOR = '#1f1a2b';

export const BACKGROUND_COLOR = '#170d28'; // NEW DARK: "#121212";
export const LIGHT_BG_FOR_CARDS = '#2a1b3b'; // for new dark: "#1E1E1E";
export const LIGHTER_BG_FOR_TOAST = LIGHT_BG_FOR_CARDS;

export const NICE_BG_FOR_CARDS = 'rgba(255, 255, 255, 0.05)';
export const NICE_BG_FOR_CARDS_HOVER = 'rgba(255, 255, 255, 0.08)';

export const GOLD_COLOR = '#FFD700';
export const DARKER_GOLD_COLOR = '#FFC400';

// THIS NEEDS TO BE BE UPDATED WITH EACH NEW DEPLOY TO PREVIEW!
export const previewBaseBaseUrl =
  'https://deploy-preview-74--onlyfakes.netlify.app';

export const PREVIEW_URL_FOR_FUNCTIONS = `${previewBaseBaseUrl}/.netlify/functions`;

export const BASE_URL = 'https://TheUncensored.AI';
export const BASE_URL_FOR_FUNCTIONS = `${BASE_URL}/.netlify/functions`;

export const FEED_BASE_URL = `${BASE_URL}/app/feed`;

export const MAX_WIDTH = 445;

export const DESKTOP_WIDTH = 1260;

export const MS_IN_SECOND = 1000;

export const PICARUS_URL = 'https://picarus.ai';
export const PICARUS_PROFILE_URL = 'https://picarus.ai/app/profile';

export const ANON_NAME_TO_USE = 'Anonymous';
